import React from 'react';
import cn from 'classnames';
import IconCancel from '@creditflowresearch/uilib/Icon/IconCancel';
import styles from './tag.module.scss';

interface IProps {
  title: React.ReactNode,
  onClick?: () => void,
  className?: string,
  allowedToRemove?: boolean,
  dataTest?: string,
}

const Tag = ({ title, onClick, className, allowedToRemove = true, dataTest = 'tag' }: IProps) => (
  <div className={ cn(styles.tag, className) } onClick={ onClick } data-test={ dataTest } data-testid={ dataTest }>
    <span className={ styles.tagTitle }>{ title }</span>
    { typeof onClick === 'function' && (
      <span className={ cn(styles.tagDeleteBtn, { [styles.isDisabled]: !allowedToRemove }) }>
        <IconCancel />
      </span>
    ) }
  </div>
);

export default Tag;
